<div [formGroup]="formGroup">
  <mat-form-field class="small-input" appearance="outline">
    <mat-label *ngIf="required && !readonly">{{ schema.label }} *</mat-label>
    <mat-label *ngIf="!required || readonly">{{ schema.label }}</mat-label>
    <input matInput digitOnly [decimal]="true" type="text" currencyMask [options]="{precision:2}"
        [formControlName]="schema.variavel" maxlength="6" [required]="schema.obrigatorio">
  </mat-form-field>
</div>
